export const asset = {
  HEB: {
    accountType: "סוג חשבון",
    balance: "יתרה",
    interest: "ריבית",
    sourceOriginalCurrency: "יתרת מטבע מקור",
    liquidity: "ניתן למימוש מיידי",
    ownership: "חלקך היחסי",
    yes: "כן",
    no: "לא",
    inputLabels: {
      address: "כתובת הנכס",
      city: "עיר",
      street: "רחוב",
      postalCode: "מיקוד",
      houseNumber: "מס' בית",
    },
    tooltips: {
      name: "תיאור קצר שיעזור לך למצוא אותו בקלות",
    },
    currency: "מטבע",
    country: "מדינה",
    predictedValueIncrease: "עליית ערך חזויה",
    delete: "מחיקה",
    cancel: "ביטול",
    bankName: "שם הבנק",
    pensionName: "שם הקופה / פנסיה",
    shareName: "שם תיק ניירות ערך",
    cryptoName: "שם ארנק הקריפטו",
    debtName: "שם ההלוואה",
    realestateName: 'שם הנדל"ן',
    generalName: "שם הנכס",
    deleteOpenFinanceProduct: `מוצר זה נוסף בצורה אוטומטית ע"י חיבור לבנק, אם תבחר למחוק אותו ניאלץ למחוק את כל ההמוצרים שהגיעו מחיבור זה במידה ויש כאלה.
     האם ברצונך למחוק את כל המוצרים של הבנק?`,
    deleteRow: `האם ברצונך למחוק שורה זו?
    לא יהיה ניתן לשחזר את המידע שנמחק.`,
    deleteProduct: `האם ברצונך למחוק את המוצר`,
    deleteOpenFinanceConnection1: `האם ברצונך להתנתקן מהחיבור ל`,
    deleteOpenFinanceConnection2: "אם תבחר למחוק אותו ניאלץ למחוק את כל ההמוצרים שהגיעו מחיבור זה במידה ויש כאלה",
    family_member_delete1: "האם ברצונך להסיר את",
    family_member_delete2: "מהמשפחה?",
    transaction_rule_delete1: "האם ברצונך למחוק את הכלל",
    transaction_rule_delete2: "",
    // Sidebar / product flow
    categories: "קטגוריות",
    addManually: "הוספה ידנית",
    cryptoPremiumLock: "סנכרון אוטומטי לארנקי קריפטו זמין רק למנויי פרימיום",
    refreshingAssets: "מעדכנים את נתוני הנכסים...",
    loadingAssets: "טוען את הנכסים...",
  },
  ENG: {
    accountType: "Account type",
    balance: "Balance",
    interest: "Interest",
    sourceOriginalCurrency: "Source currency balance",
    liquidity: "Available for immediate redemption",
    ownership: "Your relative share",
    yes: "Yes",
    no: "No",
    inputLabels: {
      address: "Property address",
      city: "City",
      street: "Street",
      postalCode: "Postal code",
      houseNumber: "House number",
    },
    tooltips: {
      name: "A short description to help you find it easily",
    },
    currency: "Currency",
    country: "Country",
    predictedValueIncrease: "Predicted value increase",
    delete: "Delete",
    cancel: "Cancel",
    bankName: "Bank name",
    pensionName: "Fund / pension name",
    shareName: "Securities portfolio name",
    cryptoName: "Crypto wallet name",
    debtName: "Loan name",
    realestateName: "Real estate name",
    generalName: "Asset name",
    deleteOpenFinanceProduct: "This product was automatically added via a bank connection. If you choose to delete it, all products from this connection will also be deleted. Do you want to delete all products from this bank?",
    deleteRow: "Do you want to delete this row?\nThe deleted data cannot be recovered.",
    deleteProduct: "Do you want to delete this product",
    deleteOpenFinanceConnection1: "Do you want to disconnect from ",
    deleteOpenFinanceConnection2: "If you choose to delete it, all products from this connection will also be deleted",
    family_member_delete1: "Do you want to remove",
    family_member_delete2: "from the family?",
    transaction_rule_delete1: "Do you want to delete the rule",
    transaction_rule_delete2: "",
    // Sidebar / product flow
    categories: "Categories",
    addManually: "Add manually",
    cryptoPremiumLock: "Automatic sync for crypto wallets is available for premium subscribers only",
    refreshingAssets: "Updating asset data...",
    loadingAssets: "Loading your assets...",
  },
  RUS: {
    accountType: "Тип счёта",
    balance: "Баланс",
    interest: "Процентная ставка",
    sourceOriginalCurrency: "Баланс в валюте",
    liquidity: "Ликвидность",
    ownership: "Доля",
    yes: "Да",
    no: "Нет",
    inputLabels: {
      address: "Адрес объекта",
      city: "Город",
      street: "Улица",
      postalCode: "Почтовый индекс",
      houseNumber: "Номер дома",
    },
    tooltips: {
      name: "Краткое описание, которое поможет вам легко его найти",
    },
    currency: "Валюта",
    country: "Страна",
    predictedValueIncrease: "Прогнозируемый рост стоимости",
    delete: "Удалить",
    cancel: "Отмена",
    bankName: "Название банка",
    pensionName: "Название фонда / пенсии",
    shareName: "Название портфеля ценных бумаг",
    cryptoName: "Название криптокошелька",
    debtName: "Название кредита",
    realestateName: "Название недвижимости",
    generalName: "Название актива",
    deleteOpenFinanceProduct: "Этот продукт был добавлен автоматически через подключение к банку. Если вы решите удалить его, все продукты из этого подключения также будут удалены. Вы хотите удалить все продукты этого банка?",
    deleteRow: "Вы хотите удалить эту строку?\nУдалённые данные невозможно восстановить.",
    deleteProduct: "Вы хотите удалить этот продукт",
    deleteOpenFinanceConnection1: "Вы хотите отключиться от ",
    deleteOpenFinanceConnection2: "Если вы решите удалить его, все продукты из этого подключения также будут удалены",
    family_member_delete1: "Вы хотите удалить",
    family_member_delete2: "из семьи?",
    transaction_rule_delete1: "Вы хотите удалить правило",
    transaction_rule_delete2: "",
    // Sidebar / product flow
    categories: "Категории",
    addManually: "Добавить вручную",
    cryptoPremiumLock: "Только Премиум: криптокошельки",
    refreshingAssets: "Обновляем данные активов...",
    loadingAssets: "Загружаем активы...",
  },
};
